import { render } from "./LicenseContact.vue?vue&type=template&id=90a8b41a&scoped=true"
import script from "./LicenseContact.vue?vue&type=script&lang=js"
export * from "./LicenseContact.vue?vue&type=script&lang=js"

import "./LicenseContact.vue?vue&type=style&index=0&id=90a8b41a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90a8b41a"]])

export default __exports__